// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ajuste dos controles do MapLibre ao vocabulário visual do Viewer. */

.maplibregl-ctrl-group {
  background: #ffffff;
  border: 1px solid #d7dfd5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(18, 63, 43, 0.12);
}

.maplibregl-ctrl-group button + button {
  border-top: 1px solid var(--linha);
}

.maplibregl-ctrl-group button:not(:disabled):hover {
  background: var(--papel-2);
}

.maplibregl-ctrl-scale {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--linha-forte);
  border-top: none;
  color: var(--tinta-media);
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
}

.maplibregl-ctrl-attrib {
  background: rgba(255, 255, 255, 0.9);
  font-size: var(--texto-xs);
}

.maplibregl-ctrl-attrib a {
  color: var(--tinta-media);
}

.maplibregl-popup-content {
  padding: var(--espaco-3);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio);
  box-shadow: var(--sombra-flutuante);
  color: var(--tinta);
  font-family: var(--fonte-ui);
  font-size: var(--texto-sm);
}

.maplibregl-popup-close-button {
  color: var(--tinta-suave);
  font-size: var(--texto-lg);
  padding: 0 var(--espaco-2);
}

.maplibregl-popup-close-button:hover {
  background: transparent;
  color: var(--tinta);
}

/* O cursor indica que a feição é selecionável. */
.mapa__tela .maplibregl-canvas-container[data-selecionavel='sim'] {
  cursor: pointer;
}

/* Controles cartográficos complementares sobrepostos ao mapa. */
.controles-cartograficos {
  position: absolute;
  z-index: 4;
  top: var(--espaco-3);
  left: var(--espaco-3);
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
}

.controles-cartograficos__botao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: #ffffff;
  border: 1px solid #d7dfd5;
  border-radius: 8px;
  color: #123f2b;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(18, 63, 43, 0.12);
  transition: background var(--transicao), color var(--transicao), border-color var(--transicao);
}

.controles-cartograficos__botao:hover {
  background: #f1f5ee;
  color: #123f2b;
}

.controles-cartograficos__botao[aria-pressed='true'] {
  background: #e9f0e8;
  color: #123f2b;
  border-color: #83a992;
}

.controles-cartograficos__botao:focus-visible {
  outline: 2px solid #2a8a5f;
  outline-offset: 2px;
}

.controles-cartograficos__botao svg {
  width: 14px;
  height: 14px;
}

/* Conjunto de legendas sobrepostas ao mapa (hipsométrica + cartográfica). */
.mapa__legendas {
  position: absolute;
  z-index: 4;
  /* Abaixo da coluna de três controles cartográficos (12 px + 3 × 36 px + 2 × 4 px). */
  top: 140px;
  left: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(260px, calc(100% - 24px));
  max-height: calc(100% - 164px);
  pointer-events: none;
}

.mapa__legendas .legenda-hipsometrica {
  position: static;
  width: 100%;
  flex: 0 0 auto;
  pointer-events: none;
}

/* Legenda hipsométrica (DEM), sobreposta ao mapa. */
.legenda-hipsometrica {
  position: absolute;
  z-index: 4;
  top: 64px;
  left: 12px;
  width: 236px;
  box-sizing: border-box;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #d7dfd5;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.12);
  color: #17251f;
  font-family: var(--fonte-ui);
  pointer-events: none;
}

.legenda-hipsometrica__titulo {
  font-size: 13px;
  font-weight: 700;
  color: #123f2b;
}

.legenda-hipsometrica__subtitulo {
  margin-top: 2px;
  font-size: 11px;
  color: #607168;
}

.legenda-hipsometrica__barra {
  width: 100%;
  height: 12px;
  margin-top: 10px;
  border-radius: 4px;
}

.legenda-hipsometrica__marcadores {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 7px;
}

.legenda-hipsometrica__marcadores-linha {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #4a5b54;
  font-size: 10px;
  line-height: 1.3;
  white-space: nowrap;
}

.legenda-hipsometrica__marcadores-linha--secundaria {
  color: #6b7a72;
}

.legenda-hipsometrica__nota {
  margin-top: 8px;
  font-size: 10px;
  color: #6b7a72;
}

/* Legenda cartográfica dinâmica (camadas ativas, seleção e operação). */
.legenda-cartografica {
  flex: 0 1 auto;
  min-height: 0;
  box-sizing: border-box;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #d7dfd5;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.12);
  color: #17251f;
  font-family: var(--fonte-ui);
  overflow-x: hidden;
  overflow-y: auto;
}

.mapa__legendas .legenda-cartografica {
  pointer-events: auto;
}

.legenda-cartografica__titulo {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  color: #123f2b;
}

.legenda-cartografica__lista {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.legenda-cartografica__item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
}

.legenda-cartografica__amostra {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.legenda-cartografica__simbolo {
  display: block;
  flex: 0 0 auto;
}

.legenda-cartografica__nome {
  min-width: 0;
  font-size: 11px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

@media (max-width: 760px) {
  .mapa__legendas {
    width: min(260px, calc(100% - 24px));
  }

  .controles-cartograficos {
    top: 12px;
    left: 12px;
  }
}

/* Seletor contextual de feições sobrepostas, posicionado junto ao ponto clicado. */
.seletor-contextual {
  position: absolute;
  z-index: 6;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: min(280px, calc(100% - 16px));
  max-height: calc(100% - 16px);
  padding: 10px;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid #d7dfd5;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.18);
  color: #17251f;
  font-family: var(--fonte-ui);
}

.seletor-contextual__cabecalho {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.seletor-contextual__titulo {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #123f2b;
}

.seletor-contextual__subtitulo {
  margin: 2px 0 0;
  font-size: 11px;
  color: #607168;
}

.seletor-contextual__fechar {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #4a5b54;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.seletor-contextual__fechar:hover {
  background: #f1f5ee;
  color: #123f2b;
}

.seletor-contextual__fechar:focus-visible,
.seletor-contextual__opcao:focus-visible {
  outline: 2px solid #2a8a5f;
  outline-offset: 2px;
}

.seletor-contextual__lista {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 4px;
  min-height: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
}

.seletor-contextual__opcao {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
  padding: 8px 10px;
  background: #ffffff;
  border: 1px solid #d7dfd5;
  border-radius: 8px;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background var(--transicao), border-color var(--transicao);
}

.seletor-contextual__opcao:hover {
  background: #f1f5ee;
  border-color: #83a992;
}

.seletor-contextual__nome {
  max-width: 100%;
  font-size: 13px;
  font-weight: 700;
  color: #123f2b;
  overflow-wrap: anywhere;
}

.seletor-contextual__detalhe {
  max-width: 100%;
  font-size: 11px;
  color: #607168;
  overflow-wrap: anywhere;
}

/* Medição cartográfica: painel de desenho e de resultado ao lado dos controles cartográficos. */
.medicao-cartografica {
  position: absolute;
  z-index: 5;
  /* Canto superior direito da área cartográfica, à esquerda do painel lateral de exploração. */
  top: 16px;
  right: calc(min(var(--largura-exploracao), 100%) + 16px);
  box-sizing: border-box;
  width: min(340px, max(220px, calc(100% - var(--largura-exploracao) - 96px)));
  max-height: calc(100% - 32px);
  padding: 12px 14px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #d7dfd5;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.18);
  color: #17251f;
  font-family: var(--fonte-ui);
}

.medicao-cartografica__titulo {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 700;
  color: #123f2b;
}

.medicao-cartografica__texto,
.medicao-cartografica__nota {
  margin: 0 0 4px;
  font-size: 11px;
  line-height: 1.4;
  color: #4a5b54;
  overflow-wrap: anywhere;
}

.medicao-cartografica__nota {
  color: #607168;
}

.medicao-cartografica__resultado {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 600;
  color: #17251f;
  overflow-wrap: anywhere;
}

.medicao-cartografica__erro {
  margin: 0 0 4px;
  font-size: 11px;
  color: var(--erro);
  overflow-wrap: anywhere;
}

.medicao-cartografica__acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.medicao-cartografica__botao {
  flex: 1 1 auto;
  min-height: 32px;
  padding: 4px 10px;
  background: #ffffff;
  border: 1px solid #83a992;
  border-radius: 8px;
  color: #123f2b;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--transicao), border-color var(--transicao);
}

.medicao-cartografica__botao:hover:not(:disabled) {
  background: #e9f0e8;
  border-color: #123f2b;
}

.medicao-cartografica__botao--primario {
  background: #123f2b;
  border-color: #123f2b;
  color: #ffffff;
}

.medicao-cartografica__botao--primario:hover:not(:disabled) {
  background: #1f6846;
  border-color: #1f6846;
}

.medicao-cartografica__botao:disabled {
  background: #eef2ec;
  border-color: #c8d0c3;
  color: #6b7a72;
  cursor: not-allowed;
}

.medicao-cartografica__botao:focus-visible {
  outline: 2px solid #2a8a5f;
  outline-offset: 2px;
}

.medicao-cartografica__botao--exportar {
  flex: 0 1 auto;
  background: transparent;
  border-color: #b4c7bb;
  color: #2d5440;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mapa.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,8FAA8F;AAChG;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,UAAU;EACV,qFAAqF;EACrF,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;EACpC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA,gGAAgG;AAChG;EACE,kBAAkB;EAClB,UAAU;EACV,6FAA6F;EAC7F,SAAS;EACT,wDAAwD;EACxD,sBAAsB;EACtB,4EAA4E;EAC5E,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Ajuste dos controles do MapLibre ao vocabulário visual do Viewer. */\r\n\r\n.maplibregl-ctrl-group {\r\n  background: #ffffff;\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(18, 63, 43, 0.12);\r\n}\r\n\r\n.maplibregl-ctrl-group button + button {\r\n  border-top: 1px solid var(--linha);\r\n}\r\n\r\n.maplibregl-ctrl-group button:not(:disabled):hover {\r\n  background: var(--papel-2);\r\n}\r\n\r\n.maplibregl-ctrl-scale {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border: 1px solid var(--linha-forte);\r\n  border-top: none;\r\n  color: var(--tinta-media);\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.maplibregl-ctrl-attrib {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.maplibregl-ctrl-attrib a {\r\n  color: var(--tinta-media);\r\n}\r\n\r\n.maplibregl-popup-content {\r\n  padding: var(--espaco-3);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n  box-shadow: var(--sombra-flutuante);\r\n  color: var(--tinta);\r\n  font-family: var(--fonte-ui);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.maplibregl-popup-close-button {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-lg);\r\n  padding: 0 var(--espaco-2);\r\n}\r\n\r\n.maplibregl-popup-close-button:hover {\r\n  background: transparent;\r\n  color: var(--tinta);\r\n}\r\n\r\n/* O cursor indica que a feição é selecionável. */\r\n.mapa__tela .maplibregl-canvas-container[data-selecionavel='sim'] {\r\n  cursor: pointer;\r\n}\r\n\r\n/* Controles cartográficos complementares sobrepostos ao mapa. */\r\n.controles-cartograficos {\r\n  position: absolute;\r\n  z-index: 4;\r\n  top: var(--espaco-3);\r\n  left: var(--espaco-3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n}\r\n\r\n.controles-cartograficos__botao {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 0;\r\n  background: #ffffff;\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 8px;\r\n  color: #123f2b;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 8px rgba(18, 63, 43, 0.12);\r\n  transition: background var(--transicao), color var(--transicao), border-color var(--transicao);\r\n}\r\n\r\n.controles-cartograficos__botao:hover {\r\n  background: #f1f5ee;\r\n  color: #123f2b;\r\n}\r\n\r\n.controles-cartograficos__botao[aria-pressed='true'] {\r\n  background: #e9f0e8;\r\n  color: #123f2b;\r\n  border-color: #83a992;\r\n}\r\n\r\n.controles-cartograficos__botao:focus-visible {\r\n  outline: 2px solid #2a8a5f;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.controles-cartograficos__botao svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n/* Conjunto de legendas sobrepostas ao mapa (hipsométrica + cartográfica). */\r\n.mapa__legendas {\r\n  position: absolute;\r\n  z-index: 4;\r\n  /* Abaixo da coluna de três controles cartográficos (12 px + 3 × 36 px + 2 × 4 px). */\r\n  top: 140px;\r\n  left: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  width: min(260px, calc(100% - 24px));\r\n  max-height: calc(100% - 164px);\r\n  pointer-events: none;\r\n}\r\n\r\n.mapa__legendas .legenda-hipsometrica {\r\n  position: static;\r\n  width: 100%;\r\n  flex: 0 0 auto;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Legenda hipsométrica (DEM), sobreposta ao mapa. */\r\n.legenda-hipsometrica {\r\n  position: absolute;\r\n  z-index: 4;\r\n  top: 64px;\r\n  left: 12px;\r\n  width: 236px;\r\n  box-sizing: border-box;\r\n  padding: 12px 14px;\r\n  background: rgba(255, 255, 255, 0.94);\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.12);\r\n  color: #17251f;\r\n  font-family: var(--fonte-ui);\r\n  pointer-events: none;\r\n}\r\n\r\n.legenda-hipsometrica__titulo {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #123f2b;\r\n}\r\n\r\n.legenda-hipsometrica__subtitulo {\r\n  margin-top: 2px;\r\n  font-size: 11px;\r\n  color: #607168;\r\n}\r\n\r\n.legenda-hipsometrica__barra {\r\n  width: 100%;\r\n  height: 12px;\r\n  margin-top: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.legenda-hipsometrica__marcadores {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  margin-top: 7px;\r\n}\r\n\r\n.legenda-hipsometrica__marcadores-linha {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  color: #4a5b54;\r\n  font-size: 10px;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n}\r\n\r\n.legenda-hipsometrica__marcadores-linha--secundaria {\r\n  color: #6b7a72;\r\n}\r\n\r\n.legenda-hipsometrica__nota {\r\n  margin-top: 8px;\r\n  font-size: 10px;\r\n  color: #6b7a72;\r\n}\r\n\r\n/* Legenda cartográfica dinâmica (camadas ativas, seleção e operação). */\r\n.legenda-cartografica {\r\n  flex: 0 1 auto;\r\n  min-height: 0;\r\n  box-sizing: border-box;\r\n  padding: 12px 14px;\r\n  background: rgba(255, 255, 255, 0.94);\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.12);\r\n  color: #17251f;\r\n  font-family: var(--fonte-ui);\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.mapa__legendas .legenda-cartografica {\r\n  pointer-events: auto;\r\n}\r\n\r\n.legenda-cartografica__titulo {\r\n  margin: 0 0 10px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #123f2b;\r\n}\r\n\r\n.legenda-cartografica__lista {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.legenda-cartografica__item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  margin: 0;\r\n}\r\n\r\n.legenda-cartografica__amostra {\r\n  flex: 0 0 20px;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.legenda-cartografica__simbolo {\r\n  display: block;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.legenda-cartografica__nome {\r\n  min-width: 0;\r\n  font-size: 11px;\r\n  line-height: 1.4;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .mapa__legendas {\r\n    width: min(260px, calc(100% - 24px));\r\n  }\r\n\r\n  .controles-cartograficos {\r\n    top: 12px;\r\n    left: 12px;\r\n  }\r\n}\r\n\r\n/* Seletor contextual de feições sobrepostas, posicionado junto ao ponto clicado. */\r\n.seletor-contextual {\r\n  position: absolute;\r\n  z-index: 6;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-sizing: border-box;\r\n  width: min(280px, calc(100% - 16px));\r\n  max-height: calc(100% - 16px);\r\n  padding: 10px;\r\n  background: rgba(255, 255, 255, 0.97);\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.18);\r\n  color: #17251f;\r\n  font-family: var(--fonte-ui);\r\n}\r\n\r\n.seletor-contextual__cabecalho {\r\n  display: flex;\r\n  flex: 0 0 auto;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.seletor-contextual__titulo {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #123f2b;\r\n}\r\n\r\n.seletor-contextual__subtitulo {\r\n  margin: 2px 0 0;\r\n  font-size: 11px;\r\n  color: #607168;\r\n}\r\n\r\n.seletor-contextual__fechar {\r\n  flex: 0 0 auto;\r\n  width: 28px;\r\n  height: 28px;\r\n  padding: 0;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  color: #4a5b54;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.seletor-contextual__fechar:hover {\r\n  background: #f1f5ee;\r\n  color: #123f2b;\r\n}\r\n\r\n.seletor-contextual__fechar:focus-visible,\r\n.seletor-contextual__opcao:focus-visible {\r\n  outline: 2px solid #2a8a5f;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.seletor-contextual__lista {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 auto;\r\n  gap: 4px;\r\n  min-height: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  overflow-y: auto;\r\n}\r\n\r\n.seletor-contextual__opcao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 2px;\r\n  width: 100%;\r\n  min-height: 44px;\r\n  box-sizing: border-box;\r\n  padding: 8px 10px;\r\n  background: #ffffff;\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 8px;\r\n  color: inherit;\r\n  font: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background var(--transicao), border-color var(--transicao);\r\n}\r\n\r\n.seletor-contextual__opcao:hover {\r\n  background: #f1f5ee;\r\n  border-color: #83a992;\r\n}\r\n\r\n.seletor-contextual__nome {\r\n  max-width: 100%;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #123f2b;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.seletor-contextual__detalhe {\r\n  max-width: 100%;\r\n  font-size: 11px;\r\n  color: #607168;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n/* Medição cartográfica: painel de desenho e de resultado ao lado dos controles cartográficos. */\r\n.medicao-cartografica {\r\n  position: absolute;\r\n  z-index: 5;\r\n  /* Canto superior direito da área cartográfica, à esquerda do painel lateral de exploração. */\r\n  top: 16px;\r\n  right: calc(min(var(--largura-exploracao), 100%) + 16px);\r\n  box-sizing: border-box;\r\n  width: min(340px, max(220px, calc(100% - var(--largura-exploracao) - 96px)));\r\n  max-height: calc(100% - 32px);\r\n  padding: 12px 14px;\r\n  overflow-y: auto;\r\n  background: #ffffff;\r\n  border: 1px solid #d7dfd5;\r\n  border-radius: 10px;\r\n  box-shadow: 0 3px 12px rgba(18, 63, 43, 0.18);\r\n  color: #17251f;\r\n  font-family: var(--fonte-ui);\r\n}\r\n\r\n.medicao-cartografica__titulo {\r\n  margin: 0 0 4px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #123f2b;\r\n}\r\n\r\n.medicao-cartografica__texto,\r\n.medicao-cartografica__nota {\r\n  margin: 0 0 4px;\r\n  font-size: 11px;\r\n  line-height: 1.4;\r\n  color: #4a5b54;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.medicao-cartografica__nota {\r\n  color: #607168;\r\n}\r\n\r\n.medicao-cartografica__resultado {\r\n  margin: 0 0 4px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #17251f;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.medicao-cartografica__erro {\r\n  margin: 0 0 4px;\r\n  font-size: 11px;\r\n  color: var(--erro);\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.medicao-cartografica__acoes {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.medicao-cartografica__botao {\r\n  flex: 1 1 auto;\r\n  min-height: 32px;\r\n  padding: 4px 10px;\r\n  background: #ffffff;\r\n  border: 1px solid #83a992;\r\n  border-radius: 8px;\r\n  color: #123f2b;\r\n  font: inherit;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background var(--transicao), border-color var(--transicao);\r\n}\r\n\r\n.medicao-cartografica__botao:hover:not(:disabled) {\r\n  background: #e9f0e8;\r\n  border-color: #123f2b;\r\n}\r\n\r\n.medicao-cartografica__botao--primario {\r\n  background: #123f2b;\r\n  border-color: #123f2b;\r\n  color: #ffffff;\r\n}\r\n\r\n.medicao-cartografica__botao--primario:hover:not(:disabled) {\r\n  background: #1f6846;\r\n  border-color: #1f6846;\r\n}\r\n\r\n.medicao-cartografica__botao:disabled {\r\n  background: #eef2ec;\r\n  border-color: #c8d0c3;\r\n  color: #6b7a72;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.medicao-cartografica__botao:focus-visible {\r\n  outline: 2px solid #2a8a5f;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.medicao-cartografica__botao--exportar {\r\n  flex: 0 1 auto;\r\n  background: transparent;\r\n  border-color: #b4c7bb;\r\n  color: #2d5440;\r\n  font-weight: 500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
